<div *ngIf="minicart" class="grid gap-2 grid-cols-[repeat(2,1fr)]">
    <div class="col-span-1 h-[87px] overflow-hidden ">
        <img class="w-full" [src]="imageSrc" [alt]="line.color.colorCode">
    </div>
    <div class="col-span-1">
        <div class="flex flex-col gap-1">
            <div>
                <div class="flex justify-between items-center">
                    <span class="typography-title-s">
                        {{getColorText()}}
                    </span>
                    <img class="cursor-pointer" src="assets/icons/trashcan-black.svg" alt="Delete" (click)="removeFromCart(line)">
                </div>
                <span class="typography-body-xs-regular">
                    {{getBrandText()}}®
                </span>
            </div>
            <span class="typography-body-s-light">
                {{'global.thickness' | translate}}: {{getThickness() | number: '1.0-1' }}cm
            </span>
            <span class="typography-body-s-light mb-1">
                {{'global.finish' | translate}}: {{finishLabel}}
            </span>
        </div>
    </div>
    <div class="col-span-1">
        <div class="w-full">
            <app-number-stepper
                [size]="'small'"
                [value]="line.qty"
                (valueChange)="updateQuantity($event)"
                [min]="1"
                [max]="line.maxQty"
            ></app-number-stepper>
        </div>
    </div>
    <div class="col-span-1">
        <div class="flex flex-col gap-1">
            <span *ngIf="line.color.priceGroup" class="typography-body-xs-regular text-text-tertiary">
                {{'natural_stone.group' | translate}}&nbsp;{{line.color.priceGroup}}
            </span>
            <span class="typography-body-s-regular">
                {{'ID'}}: {{id}}
            </span>
        </div>
    </div>
    <div class="col-span-2">
        <span class="typography-body-xs-light text-text-tertiary">
            {{'natural_stone.with_these_boards_you_can_cover_an_area_of_approximately_measure' | translate:{varSurface: ((surfaceArea * line.qty) | number: '1.0-2' ), varMeasureUnit: getSurfaceAreaMeasure()}  }}
        </span>
    </div>
</div>

<div *ngIf="!minicart" class="flex flex-wrap gap-4">
    <div class="flex-1 flex gap-2">
        <div class="w-[127px] h-[87px] overflow-hidden flex justify-center items-center">
            <img class="w-full" [src]="imageSrc" [alt]="line.color.colorCode">
        </div>
        <div class="flex-1 flex flex-wrap gap-2">
            <div class="flex-1 min-w-[128px]">
                <div class="flex flex-col gap-1">
                    <div class="flex flex-col">
                        <span class="typography-title-m">
                            {{getColorText()}}
                        </span>
                        <span class="typography-body-xs-regular">
                            {{getBrandText()}}®
                        </span>
                    </div>
                    <span class="typography-body-m-light">
                        {{'global.thickness' | translate}}: {{getThickness() | number: '1.0-1' }}cm
                    </span>
                    <span class="typography-body-m-light">
                        {{'global.finish' | translate}}: {{finishLabel}}
                    </span>
                </div>
            </div>
            <div class="flex-1 min-w-[128px]">
                <div class="h-full flex flex-col justify-between gap-1">
                    <span class="typography-body-m-light">
                        {{(line.lot.bundleId ? 'natural_stone.bundle_id' : 'natural_stone.lot') | translate}}&nbsp;{{line.lot.bundleId ? line.lot.bundleId : line.lot.lotId}}
                    </span>
                    <div class="flex flex-col gap-1">
                        <span *ngIf="getWidth() && getHeight()" class="typography-body-m-light">
                            {{'global.size' | translate}}: {{(getWidth() | number: '1.0-2') + ' x ' + (getHeight() | number: '1.0-2') + getMeasureUnit()}}
                        </span>
                        <span *ngIf="surfaceArea" class="typography-body-m-light">
                            {{'global.surface_area' | translate}}: {{(surfaceArea | number: '1.0-2') + getSurfaceAreaMeasure()}}
                        </span>
                    </div>
                </div>
            </div>
            <div class="flex-1 min-w-[128px] flex items-end">
                <span class="typography-body-xs-light text-text-tertiary">
                    {{'natural_stone.with_these_boards_you_can_cover_an_area_of_approximately_measure' | translate:{varSurface: ((surfaceArea * line.qty) | number: '1.0-2' ), varMeasureUnit: getSurfaceAreaMeasure()}  }}
                </span>
            </div>
        </div>
    </div>
    <div class="min-w-[150px] w-min flex items-end">
        <div class="flex justify-center items-center">
            <div class="cursor-pointer flex justify-center items-center px-3" (click)="removeFromCart(line)">
                <img src="assets/icons/trashcan-black.svg" alt="Delete">
            </div>
            <div class="flex-1">
                <app-number-stepper
                    [size]="'small'"
                    [value]="line.qty"
                    (valueChange)="updateQuantity($event)"
                    [min]="1"
                    [max]="line.maxQty"
                ></app-number-stepper>
            </div>
        </div>
    </div>
</div>